import { render, staticRenderFns } from "./ModalVerMais.vue?vue&type=template&id=0dc84a2e"
import script from "./ModalVerMais.vue?vue&type=script&lang=js"
export * from "./ModalVerMais.vue?vue&type=script&lang=js"
import style0 from "./ModalVerMais.vue?vue&type=style&index=0&id=0dc84a2e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports